import { render, staticRenderFns } from "./dict-edit.vue?vue&type=template&id=c4ab9074&"
import script from "./dict-edit.vue?vue&type=script&lang=js&"
export * from "./dict-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports